import PollEdit from './PollEdit';

export default PollEdit;
